import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { ButtonContainer } from 'apps/auth/components/googlePay/styles';
import { apiFetchDataForApplePay } from 'apps/auth/helpers/api';
import { logError } from 'apps/auth/helpers/clientLogger';
import { deletingWhiteSpaceInString } from 'apps/auth/helpers/utils';

const ApplePayButton = (props) => {
    const [isButtonDisplay, setButtonDisplay] = useState(false);
    useEffect(() => {
        const checkSafariAndProtocolHttps = () => {
            if (__isDev__) {
                return Boolean(window.ApplePaySession);
            } else {
                return Boolean(window.ApplePaySession && window.ApplePaySession.canMakePayments());
            }
        };
        const isRenderButton = checkSafariAndProtocolHttps();
        setButtonDisplay(isRenderButton);
    }, []);

    const beginSession = (event) => {
        event.preventDefault();
        if (isButtonDisplay) {
            const paymentRequest = {
                countryCode: props.countryCode.toUpperCase(),
                currencyCode: props.currencyCode,
                supportedNetworks: ['visa', 'masterCard'],
                merchantCapabilities: ['supports3DS'],
                total: { label: props.paysend_apple_display_name, amount: deletingWhiteSpaceInString(props.totalPrice) },
            };

            const session = new window.ApplePaySession(1, paymentRequest);

            session.onvalidatemerchant = function (event) {
                const data = {
                    validationUrl: event.validationURL,
                };
                const path = '/auth/apple-pay/start-session.action';
                apiFetchDataForApplePay(path, data)
                    .then((merchantSession) => {
                        session.completeMerchantValidation(merchantSession);
                    })
                    .catch((err) => {
                        logError('Error fetching merchant session', err);
                    });
            };

            session.onpaymentauthorized = function (event) {
                const data = {
                    token: JSON.stringify(event.payment.token.paymentData),
                    paymentId: props.precheckId.toString(),
                    userCard: event.payment.token.paymentMethod.displayName,
                };

                const path = '/auth/apple-checkout-token.action';
                apiFetchDataForApplePay(path, data)
                    .then(function (json) {
                        const isValid = (data) => data.status === 200;
                        let status;
                        if (isValid(json)) {
                            status = window.ApplePaySession.STATUS_SUCCESS;
                            session.completePayment(status);
                            props.onClick();
                        } else {
                            status = window.ApplePaySession.STATUS_FAILURE;
                            session.completePayment(status);
                        }
                        if (json.redirectURL) {
                            props.toggleSpinner(true);
                            window.location.href = json.redirectURL;
                        }
                    })
                    .catch(function (err) {
                        logError(err);
                        session.completePayment(window.ApplePaySession.STATUS_FAILURE);
                    });
            };

            session.begin();
            return false;
        }
    };

    const layout = (
        <ButtonContainer>
            <Button type="link" raised={true} lang={props.countryCode} className="apple-pay-button apple-pay-button-black" onClick={beginSession} />
        </ButtonContainer>
    );

    return isButtonDisplay ? layout : null;
};
const mapStateToProps = (state) => {
    return {
        totalPrice: state.extra.precheck.amountFrom,
        paysend_apple_display_name: state.messages.jsMessages['paysend.apple.display.name'],
        currencyCode: state.extra.precheck.amountFromCurrency,
        countryCode: state.extra.userCountry?.code,
        precheckId: state.extra.precheck.id,
    };
};
export default connect(mapStateToProps, { toggleSpinner })(ApplePayButton);
